"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnregisterBattery = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var UnregisterBattery = function UnregisterBattery(props) {
  return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "1.85953",
    y: "10.2387",
    width: "17.998",
    height: "9.03535",
    rx: "2.72486",
    stroke: "#13131C",
    strokeWidth: "1.72102",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.0002 14.9365C23.0002 15.9725 22.5513 16.4098 22.1722 16.5944C21.9052 16.7245 21.6558 16.4885 21.6558 16.1914V13.6816C21.6558 13.3846 21.9052 13.1486 22.1722 13.2786C22.5513 13.4632 23.0002 13.9006 23.0002 14.9365Z",
    fill: "#13131C"
  }), /*#__PURE__*/_react.default.createElement("g", {
    clipPath: "url(#clip0_1079_17171)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.6809 15.8321C13.6512 15.8321 16.0591 13.4242 16.0591 10.4539C16.0591 7.48358 13.6512 5.07568 10.6809 5.07568C7.71063 5.07568 5.30273 7.48358 5.30273 10.4539C5.30273 13.4242 7.71063 15.8321 10.6809 15.8321Z",
    fill: "white",
    stroke: "#D81A26",
    strokeWidth: "1.72102",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.52979 10.4539H12.8323",
    stroke: "#D81A26",
    strokeWidth: "1.72102",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("clipPath", {
    id: "clip0_1079_17171"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    width: "12.9076",
    height: "12.9076",
    fill: "white",
    transform: "translate(4.22705 4)"
  }))));
};
exports.UnregisterBattery = UnregisterBattery;